<template>
  <div>
    <div class="form-group">
      <label for="amount">Invoice amount</label>
      <input class="form-control" maxlength="12" v-model="amount" type="num" name="amount" id="amount">
    </div>
    <div class="form-group" v-if="hasTaxRate">
      <label for="amount">Tax rate</label>
      <select class="form-control" v-model="tax" name="tax">
        <option v-for="taxOption in taxOptions" :value="taxOption">
          {{ taxOption > 0 ? `${taxOption}%` : 'None' }}
        </option>
      </select>
    </div>
    <h3 class="estimated-salary">
      <small>Estimated salary</small>
      <br/>
      {{ salary | formatCurrency() }} {{ currency }}
    </h3>
    <button class="authSubmit btn btn-light btn-block mb-3 mt-3" type="button" data-toggle="collapse"
            data-target="#calculation" aria-expanded="false" aria-controls="calculation">
      See how we calculated this
    </button>
    <div class="collapse multi-collapse" id="calculation">
      <div v-if="country !== 'SE'" class="alert alert-warning text-readable">
        Charge does not handle taxes for your country, please follow your country's own tax regulations for a more accurate calculation.
      </div>
      <table class="table">
        <tr>
          <th>Invoice amount</th>
          <td class="text-right">{{ amount | formatCurrency }} {{ currency }}</td>
        </tr>
        <tr>
          <td>Charge Fee ({{ chargeFee }}%)</td>
          <td class="text-right">-{{ this.chargeFeeCalculation | formatCurrency }} {{ currency }}</td>
        </tr>
        <tr v-if="hasSocialFees">
          <td>Social Fees (31.42%)</td>
          <td class="text-right">-{{ this.employerFeeCalculation | formatCurrency }} {{ currency }}</td>
        </tr>
        <tr v-if="hasSocialFees">
          <th>Gross-salary incl. holiday pay</th>
          <th class="text-right">{{ this.afterEmployeeFee | formatCurrency }} {{ currency }}</th>
        </tr>
        <tr v-if="hasTaxRate">
          <td>Tax ({{ tax > 0 ? `${tax}%` : 'none' }})</td>
          <td class="text-right">-{{ this.taxesCalculation | formatCurrency }} {{ currency }}</td>
        </tr>
        <tr>
          <th>Net salary</th>
          <th class="text-right">{{ this.salary | formatCurrency }} {{ currency }}</th>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalaryCalculator',
  props: {
    country: {
      type: String,
    },
    currency: {
      type: String,
      default: 'SEK',
    },
    defaultTax: {
      type: Number,
    },
    taxOptions: {
      type: Array,
      required: true,
    },
    chargeFee: {
      type: Number,
    },
    employeeFee: {
      type: Number,
      default: 31.42
    },
  },
  data() {
    let options = this.taxOptions;
    options.unshift(this.defaultTax);
    options = options.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    return {
      amount: 0,
      options: options,
      tax: this.defaultTax || options[0],
    };
  },
  computed: {
    hasTaxRate() {
      return this.country === 'SE';
    },
    hasSocialFees() {
      return this.country === 'SE';
    },
    chargeFeeCalculation() {
      return this.amount * this.chargeFee / 100;
    },
    afterChargeFee() {
      return this.amount - this.chargeFeeCalculation;
    },
    employerFeeCalculation() {
      if (this.hasSocialFees) {
        return this.afterChargeFee - (this.afterChargeFee / this.employeeFeeDivider);
      }
      return 0;
    },
    employeeFeeDivider() {
      return 1 + (this.employeeFee / 100);
    },
    afterEmployeeFee() {
      return this.afterChargeFee - this.employerFeeCalculation;
    },

    taxesCalculation() {
      if (this.hasTaxRate) {
        return this.afterEmployeeFee * (this.tax / 100);
      }
      return 0;
    },

    salary() {
      return this.afterEmployeeFee - this.taxesCalculation;
    },
  },
};
</script>

<style lang="scss" scoped>
.estimated-salary {
  width: 100%;
  text-align: center;
  background: #0075FF;
  border-radius: 6px;
  color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 25px;

  small {
    font-size: 18px;
    font-weight: 400;
  }
}
</style>
